import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DesignAdapter {
  private http = inject(HttpClient);

  getDesign(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/company/design`);
  }

  editDesign(payload): Observable<any> {
    return this.http.patch(`${environment.apiBaseUrl}/company/design`, payload);
  }
}
